module.exports = __webpack_public_path__ + "img/overhaul_light.c1ffab5d.svg";